module.exports = __webpack_public_path__ + "img/initialImage.d70f829f.png";